import { render, staticRenderFns } from "./RegisterSxhmatismos.vue?vue&type=template&id=0b2ac54c&scoped=true"
import script from "./RegisterSxhmatismos.vue?vue&type=script&lang=js"
export * from "./RegisterSxhmatismos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2ac54c",
  null
  
)

export default component.exports